@if (task(); as task) {
    <div class="container-fluid">
        <div class="row">
            <div class="col">
                <unclaimed-message [task]="task" (claimed)="getTask()"></unclaimed-message>
            </div>
        </div>
        <div class="row justify-content-lg-end mb-2" [class.preview-toolbar]="!isMobile()">
            <div class="col">
                <h3>{{ 'Rechnung freigeben' | translate }}</h3>
            </div>
            @if (hasPdfFileAttachments()) {
                <div class="col-12 col-lg-auto">
                    <button class="btn btn-outline-dark w-100 w-lg-auto" (click)="togglePdfPreview()">
                        @if (showPdfPreview()) {
                            <em class="fas fa-eye-slash pe-1"></em>
                            {{ 'PDF Vorschau ausblenden' | translate }}
                        } @else {
                            <em class="fas fa-eye pe-1"></em>
                            {{ 'PDF Vorschau anzeigen' | translate }}
                        }
                    </button>
                </div>
            }
            @if (task.invoice.possibleActions.includes(InvoicePossibleActionType.EDIT)) {
                <div class="col-12 col-lg-auto">
                    <button class="btn btn-primary w-100 w-lg-auto" (click)="openInvoiceEditDialog()">
                        <em class="fas fa-pen pe-1"></em>
                        {{ 'Rechnung bearbeiten' | translate }}
                    </button>
                </div>
            }
        </div>

        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col">
                        @if (!isInvoiceValid() && validationErrors()?.length) {
                            <div class="alert alert-danger" role="alert">
                                <strong>{{ 'Rechnung ist ungültig' | translate }}</strong>
                                <ul class="mb-0 mt-2">
                                    @for (err of validationErrors(); track err) {
                                        <li>{{ err }}</li>
                                    }
                                </ul>
                            </div>
                        }
                        @if (accountingWarnings().length) {
                            <div class="alert alert-warning" role="alert">
                                <strong>{{ 'Hinweise zur Kontierung' | translate }}</strong>
                                <ul class="mb-0 mt-2">
                                    @for (warning of accountingWarnings(); track warning) {
                                        <li>{{ warning | translate }}</li>
                                    }
                                </ul>
                            </div>
                        }
                        <invoice-detail
                            [forceMobileLayout]="showPdfPreview()"
                            [invoice]="task.invoice"
                            [taskId]="task.id"
                            (accountingSelected)="onChangeAccounting($event)"
                            (materialGroupSelected)="onChangeMaterialGroup($event)"
                            (onAllAccountingsSelected)="onAllAccountingChanged()"
                            (accountingValidationChanged)="onAccountingValidationChanged($event)"
                            (accountingWarningsChanged)="onAccountingWarningsChanged($event)"
                        ></invoice-detail>
                    </div>
                </div>
                <div class="row justify-content-end mb-2" *removeIfUnclaimed="task">
                    <div class="col-auto">
                        <div class="btn-group">
                            <button class="btn btn-warning" (click)="decide(false)">
                                <em class="fas fa-ban pr-2"></em>
                                {{ 'ablehnen' | translate }}
                            </button>
                            <button
                                class="btn btn-success"
                                [disabled]="
                                    isCompleted ||
                                    !isInvoiceValid() ||
                                    isValidating() ||
                                    !task.userAllowedToApprove ||
                                    !isInvoiceAccountingValid()
                                "
                                (click)="decide(true)"
                            >
                                <em class="fas fa-check pr-2"></em>
                                {{ 'freigeben' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            @if (showPdfPreview()) {
                <div class="col-6">
                    <div class="pdf-sticky-wrapper">
                        @if (pdfSideBySide.isOpen()) {
                            <document-pdf-side-by-side></document-pdf-side-by-side>
                        } @else {
                            <pdf-preview [files]="invoiceFiles()"></pdf-preview>
                        }
                    </div>
                </div>
            }
        </div>
        <div class="row justify-content-end mb-2">
            <div class="col-auto">
                <task-hint-display [hint]="task.hint"></task-hint-display>
            </div>
        </div>
        <div class="row justify-content-end mb-2" *showIfUnclaimed="task">
            <claim-btn [task]="task" (claimed)="getTask()"></claim-btn>
        </div>
    </div>
}
